import { useEffect } from "react"

export const useAutostartTokenEffect = (autostartToken: string) => {
  useEffect(() => {
    window.location.href = `bankid:///?autostarttoken=${autostartToken}&redirect=null`
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
